export const parseJson = <T = unknown>(raw: string | null | undefined): T | undefined => {
  if (typeof raw !== 'string' || raw.trim() === '') return undefined

  try {
    return JSON.parse(raw)
  } catch {
    return undefined
  }
}
